import styles from "./Loader.module.scss"

export function Loader() {
  return <div className={styles.wrap}>{/*<div className={styles.loader} />*/}</div>
}
